export default "__VITE_ASSET__CZCNQ90H__"